import React from 'react'

interface ManualAddImportIconProps {
  color?: string
  size?: number
}

/**
 * Manual Add/Import icon for competition setup wizard
 */
const ManualAddImportIcon: React.FC<ManualAddImportIconProps> = ({
  color = '#F2B400',
  size = 40,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
    >
      <path
        d='M33.3333 9.99984H19.9999L16.6666 6.6665H6.66659C4.83325 6.6665 3.34992 8.1665 3.34992 9.99984L3.33325 29.9998C3.33325 31.8332 4.83325 33.3332 6.66659 33.3332H33.3333C35.1666 33.3332 36.6666 31.8332 36.6666 29.9998V13.3332C36.6666 11.4998 35.1666 9.99984 33.3333 9.99984ZM33.3333 29.9998H6.66659V9.99984H15.2833L18.6166 13.3332H33.3333V29.9998ZM15.6833 24.0332L18.3333 21.3998V28.3332H21.6666V21.3998L24.3166 24.0498L26.6666 21.6832L20.0166 14.9998L13.3333 21.6832L15.6833 24.0332Z'
        fill={color}
      />
    </svg>
  )
}

export default ManualAddImportIcon
